import React, { useState, useCallback, useRef } from 'react';
import { Text, PortalOverlay, Content, Button, Flex, Pane } from '@leverege/ui-elements';
import { Attributes, AttributeDetailRenderer, DataSources } from '@leverege/ui-attributes';
import classnames from 'classnames';
import S from './Renderer.css';
import ResourceImageValueComponent from "../../resourceImage/ResourceImageValueComponent.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default class ResourceImageDetailRenderer extends AttributeDetailRenderer {
  getValueComponent(dudValues, valueSyle, obj, context) {
    const {
      showCount,
      objectType,
      attrName,
      objectFit,
      imageHeight,
      imageWidth,
      percentageHeight,
      percentageWidth,
      imagePaneVariant,
      imageBackgroundColor,
      value: {
        emptyValue,
        emptyIcon
      },
      dialog: {
        titleIcon,
        objectFit: popupObjectFit,
        imageWidth: popupImageWidth,
        imageHeight: popupImageHeight
      } = {}
    } = this.detail;
    const {
      clientProps = {}
    } = context;
    const {
      isMobile
    } = clientProps;
    const attribute = Attributes.getAttribute(attrName, objectType);
    const values = attribute?.get(obj.data);
    if (values === emptyValue || typeof values !== 'object' || !Object.keys(values).length) {
      return /*#__PURE__*/_jsx(Pane, {
        variant: imagePaneVariant,
        children: /*#__PURE__*/_jsx(Text, {
          className: classnames(S.emptyValue, S.win, S.really),
          icon: emptyIcon,
          iconOpts: {
            style: {
              fontSize: '32px'
            }
          },
          children: emptyValue
        })
      });
    }
    const keys = Object.keys(values).sort((a, b) => {
      if (values[a] > values[b]) {
        return -1;
      }
      return 1;
    });
    const childStyle = {
      objectFit,
      height: '100%',
      width: '100%',
      backgroundColor: imageBackgroundColor
    };
    const parentStyle = {
      height: imageHeight && `${imageHeight}${percentageHeight ? '%' : 'px'}`,
      width: imageWidth && `${imageWidth}${percentageWidth ? '%' : 'px'}`
    };
    const popupImageStyle = {
      objectFit: popupObjectFit,
      height: popupImageHeight && `${popupImageHeight}px`,
      width: popupImageWidth && `${popupImageWidth}px`,
      maxWidth: isMobile && '100%'
    };
    const delegate = DataSources.getActions({
      ...obj,
      ref: obj?.ref?.replace(`/${obj.id}`, '')
    });
    const imagePathRoot = attribute.blueprint.attribute.getTagStartingWith('resourceImagePrefix:', true) || `resourceImage/${attribute?.blueprint?.updatePath.slice(5)}`;
    const titleText = attribute.source.attribute.getString('titleDialogImage', `View ${attribute.displayName}`);
    return /*#__PURE__*/_jsx(Pane, {
      variant: imagePaneVariant,
      style: parentStyle,
      children: /*#__PURE__*/_jsx(DetailComponent, {
        showCount: showCount,
        isMobile: isMobile,
        values: keys,
        imagePathRoot: imagePathRoot,
        childStyle: childStyle,
        delegate: delegate,
        titleIcon: titleIcon,
        titleText: titleText,
        popupImageStyle: popupImageStyle
      })
    });
  }
}
function DetailComponent(props) {
  const {
    isMobile,
    values,
    imagePathRoot,
    childStyle,
    delegate,
    titleIcon,
    titleText,
    popupImageStyle,
    showCount
  } = props;
  const [showDialog, setShowDialog] = useState(false);
  const [viewIndex, setViewIndex] = useState(0);
  const leftButtonRef = useRef(null);
  const changeViewIndex = useCallback((index, change) => {
    if (change === 'inc') {
      if (index + 1 < values.length) {
        setViewIndex(index + 1);
      } else {
        setViewIndex(0);
      }
    } else if (change === 'dec') {
      if (index - 1 >= 0) {
        setViewIndex(index - 1);
      } else {
        setViewIndex(values.length - 1);
      }
    }
  }, [values]);
  return /*#__PURE__*/_jsxs("div", {
    style: {
      height: '100%',
      width: '100%'
    },
    onClick: e => {
      e.stopPropagation();
      setShowDialog(true);
    },
    children: [/*#__PURE__*/_jsxs("div", {
      className: S.parent,
      style: {
        height: '100%',
        width: '100%'
      },
      children: [/*#__PURE__*/_jsx(ResourceImageValueComponent, {
        value: values[viewIndex],
        path: `${imagePathRoot}/${values[viewIndex]}`,
        valueStyle: childStyle,
        clientProps: {
          delegate
        }
      }), /*#__PURE__*/_jsx(Button, {
        icon: "fa-solid fa-chevron-left",
        className: classnames(S.child, S.common, S.win, S.left),
        onClick: () => changeViewIndex(viewIndex, 'dec')
      }), showCount && /*#__PURE__*/_jsx(Text, {
        className: classnames(S.child, S.common, S.count),
        children: values.length
      }), /*#__PURE__*/_jsx(Button, {
        icon: "fa-solid fa-chevron-right",
        className: classnames(S.child, S.common, S.win, S.right),
        onClick: () => changeViewIndex(viewIndex, 'inc')
      })]
    }), /*#__PURE__*/_jsx(PortalOverlay, {
      show: showDialog,
      variant: "dialog",
      onClose: () => setShowDialog(false),
      children: /*#__PURE__*/_jsx(Pane, {
        className: classnames(S.dialogMain, isMobile ? S.mobile : S.desktop),
        children: /*#__PURE__*/_jsxs(Content, {
          relative: true,
          className: classnames(S.dialogContent, isMobile ? S.mobile : S.desktop),
          children: [/*#__PURE__*/_jsx(Content.Header, {
            variant: "dialogHeader",
            children: /*#__PURE__*/_jsxs(Flex, {
              variant: "rowSpaceBetween",
              align: "center",
              children: [/*#__PURE__*/_jsx(Text, {
                icon: titleIcon,
                variant: "dialogTitle",
                children: titleText
              }), /*#__PURE__*/_jsx(Button, {
                onClick: () => setShowDialog(false),
                variant: "closeDialog"
              })]
            })
          }), /*#__PURE__*/_jsx(Content.Area, {
            className: classnames(S.noSize, S.win, S.really),
            variant: isMobile ? 'mobileClose' : 'dialogBody',
            children: /*#__PURE__*/_jsx(Flex, {
              align: "center",
              justify: "center",
              children: /*#__PURE__*/_jsx(ResourceImageValueComponent, {
                showCreatedAt: true,
                value: values[viewIndex],
                path: `${imagePathRoot}/${values[viewIndex]}`,
                valueStyle: popupImageStyle,
                clientProps: {
                  delegate
                }
              })
            })
          }), /*#__PURE__*/_jsx(Content.Footer, {
            variant: "dialogFooter",
            children: /*#__PURE__*/_jsxs(Flex, {
              align: "center",
              justify: "center",
              variant: "rowL",
              children: [/*#__PURE__*/_jsx(Button, {
                ref: leftButtonRef,
                icon: "fa-solid fa-chevron-left",
                onClick: () => {
                  changeViewIndex(viewIndex, 'dec');
                },
                variant: isMobile ? 'secondaryIconicNoHover' : 'secondaryIconic'
              }), /*#__PURE__*/_jsxs(Text, {
                className: S.dialogText,
                children: [viewIndex + 1, " of ", values.length]
              }), /*#__PURE__*/_jsx(Button, {
                icon: "fa-solid fa-chevron-right",
                onClick: () => changeViewIndex(viewIndex, 'inc'),
                variant: isMobile ? 'secondaryIconicNoHover' : 'secondaryIconic'
              })]
            })
          })]
        })
      })
    })]
  });
}